import { BrandingThemeItem } from '@/types/brandingThemes';
import { Card, Grid, Stack, Typography } from '@mui/material';
import MobileUIDemo from '../demos/MobileUIDemo';
import { SVLabeledText } from '@/components/core';
import { GRID_ROW_STYLES } from '@/constants/common';
import IntroVideoDemo from '../demos/IntroVideoDemo';
import FontDemo from '../demos/FontDemo';

type MobileUIViewProps = {
  brandingTheme: BrandingThemeItem;
};

export default function MobileUIView({ brandingTheme }: MobileUIViewProps) {
  const {
    customNavigationBackground,
    customBottomNavigationSelectedIconColor,
    customHeroBackground,
    customHomeScreenBackground,
    primaryColor,
    secondaryColor,
    titleColor,
    titleHeroSectionColor,
    titleAccentSectionColor,
    mobileLogoUrl,
    font,
    introVideo,
  } = brandingTheme.mobileUi;

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Mobile App UI
      </Typography>
      <Grid sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={2}>
            <SVLabeledText
              label="Navigation Background"
              text={customNavigationBackground}
            />
            <SVLabeledText
              label="Hero Background"
              text={customHeroBackground}
            />
            <SVLabeledText
              label="Home Screen Background"
              text={customHomeScreenBackground}
            />
            <SVLabeledText label="Primary Color" text={primaryColor} />
            <SVLabeledText label="Secondary Color" text={secondaryColor} />
            <SVLabeledText
              label="Bottom Navigation Icon Selected Color"
              text={customBottomNavigationSelectedIconColor}
            />
            <SVLabeledText
              label="Hero Section Color"
              text={titleHeroSectionColor}
            />
            <SVLabeledText label="Title Default Color" text={titleColor} />
            <SVLabeledText
              label="Title Accent Section Color"
              text={titleAccentSectionColor}
            />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <MobileUIDemo
            navigationBackground={customNavigationBackground}
            heroBackground={customHeroBackground}
            homeScreenBackground={customHomeScreenBackground}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            bottomNavIconSelectedColor={customBottomNavigationSelectedIconColor}
            titleDefaultColor={titleColor}
            heroSectionColor={titleHeroSectionColor}
            titleAccentSectionColor={titleAccentSectionColor}
            font={font}
            logoImage={mobileLogoUrl}
          />
        </Grid>
      </Grid>
      <Grid sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText label="General Logo" text={mobileLogoUrl} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <img style={{ maxWidth: '100%' }} src={mobileLogoUrl} />
        </Grid>
      </Grid>
      <Grid sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText label="Intro Video" text={introVideo} />
        </Grid>
        <IntroVideoDemo introVideo={introVideo} />
      </Grid>
      <Grid container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText label="Font" text={font} />
        </Grid>
        <FontDemo font={font} />
      </Grid>
    </Card>
  );
}
